import Methods from '../methods';

class SVC extends Methods {
      constructor() {
            super();
            this.route = {
                  read: 'read',
                  write: 'write',
                  import: 'import',
                  clone: `blueprint/clone`,
                  export: (id, blueprintDetails) => `export/${id}/${blueprintDetails.docid}`,
                  renameBlueprint: 'blueprint/rename',
                  importCustom: 'import-custom',
                  initiateRestore: 'read-backup', 
                  deleteBackup: 'delete-backup',
                  singleBlueprintBackup: 'single-blueprint-backup',

                  getBuildFiles: 'blueprintBuildFiles',
                  getBuildFileContent: `blueprintBuildFiles/file`, 
                  
                  verifyConfig: 'configuration/verify',
                  searchBackup: 'backups/search',
                  exportJson: 'export/json',
                  downloadBlueprintJson: 'copy/blueprint-json',
                  importJson: `import/json`,
                  validateBlueprintName: 'blueprint/import/validate-name',
                  importTemplate: 'import/template', 
                  deleteMultiBackup: 'backups/deletemultiple',
                  getTemplates: 'templates/gettemplate',
                  createTemplate: '/create/template',
                  releaseBlueprint: 'blueprint/relase',
                  generateDemodata: 'views/demo-data',
                  assetList: (blueprint) => `assets/list?blueprint=${blueprint}`,
                  uploadAssets: 'assets/upload',
                  deleteAsset: 'assets/delete',
                  listParentAssets: (blueprint, parent) => `assets/parentList?blueprint=${blueprint}&parent=${parent}`,
                  luaValidate: 'validate/lua',
                  deleteAssetFolder: 'assets/delete/folder',
                  displayAsset: 'assets/display',
                  renameAsset: 'assets/rename',
                  sendInvitation: 'member/invite',
                  removeMember: 'member/remove',
                  updateMember: 'member/update',
                  transferOwnership: 'blueprint/ownership/transfer',
                  leaveFromTeam: 'member/leave',
                  audit: 'blueprint/audit',
                  verifyBlueprintExistance: 'test/does-blueprint-exist',
                  createTransaction: 'transaction/create',
                  getAllTransaction: 'transaction/read',
                  getSystemModelData: 'system-model',
                  getSystemModelConfig: "blueprint/system-model-config",
                  createEvent: 'event/create',
                  getAllEvents: 'event/read',
                  createDigitalTwin: 'digital-twin/create',
                  createClusterlet: 'clusterlet/create',
                  getClusterlets: 'clusterlets',
                  createEdge: 'edge/create',
                  deleteEdge: 'edge/delete',
                  getTransactionAssociates: 'transaction/read/with-associates',
                  deleteEvent: 'event/delete',
                  updateTransactionInfo: 'transaction/update',
                  testCode: 'test/response-code',
                  getClusterlet: 'clusterlet',
                  editClusterlet: 'clusterlet/update',
                  updateClusterlets: 'clusterlets/update',
                  updateTransactionNodes: 'transaction/nodes',
                  deleteTransaction: 'transaction/delete',
                  createMessage: 'message/create',
                  getMessages: 'message/read',
                  getBlueprintConstructs: 'blueprints/constructs',
                  deleteClusterlet: 'clusterlet/delete',
                  createRrdef: 'rrdef/create',
                  createHandler: 'handler/create',
                  getEventHandler: 'handler/event/read',
                  deleteHandler: 'handler/delete',
                  createEnterpriseApp: 'enterprise-app/create',
                  getEventData: 'event',
                  updateUtilityFunction: 'utility_function/update',
                  getUtilityFunction: 'utility_function/read',
                  getEventAssociatedData: 'event',
                  deleteUtilityFunction: 'utility_function/delete',
                  getClusterletAssocitedEvents: 'events/associated',
                  getAssociatedTransactions: 'transactions/associated',
                  getClusterletProperties: 'clusterlet/properties',
                  getSection: 'property',
                  createProperty: 'property/create',
                  editSection: 'property/update',
                  deleteSection: 'property/delete',
                  pasteSection: 'property/paste',
                  getEventClusterletInfo: 'event/clusterlet_info',
                  getEventRoutingRoule: 'event/rrdefs',
                  deleteRrdef: 'rrdef/delete',
                  getAllRrdefs: 'rrdef/read',
                  createField: 'field/create',
                  getField: 'field',
                  editField: 'field/update',
                  deleteField: 'field/delete',
                  pasteField: 'field/paste',
                  deleteUserTrigger: 'user-trigger/delete',
                  createUserTrigger: 'user-trigger/create',
                  editUserTrigger: 'user-trigger/edit',
                  getSingleUt: 'user-trigger',
                  updateMessage: 'eventtype/update',
                  createDelegate: 'delegate/create',
                  moveSection: 'property/move',
                  moveField: 'field/move',
                  updateEventOrder: 'transaction/event/update',
                  createNestedTransaction: 'transaction/nested-transaction/create',
                  updateNestedTransaction: 'transaction/nested-transaction/update',
                  deleteNestedTransaction: 'transaction/nested-transaction/delete',
                  createInvokedTransaction: 'transaction/invoked-transaction/create',
                  updateClusterletOrder: 'transaction/clusterlet/update',
                  getDelegate: 'delegate',
                  editDelegate: 'delegate/update',
                  updateClusterletPosition: 'clusterlet/position/update',
                  getAllFields: 'field/read',
                  deleteMessage: 'message/delete',
                  createView: 'view/create',
                  getView: 'view',
                  updateView: 'view/update',
                  createBlueprint: 'blueprint/create',
                  getBlueprintList: 'blueprints/list',
                  deleteBlueprint: 'blueprint/delete',
                  updateEvent: 'event/update',
                  updateEventTarget: 'event/update/target',
                  getBlueprintSharedMembers: 'members/list',
                  updateRrdef: 'rrdef/update',
                  getHighLevelEvents: 'events/highlevel',
                  deleteView: 'view/delete',
                  cloneView: 'view/clone',
                  viewUpdateDefault: 'view/default',
                  viewMappingTreeDependencies: 'dependencies/view/mappingtree',
                  getClusterletAssociatedRoutingRules: 'rrdefs/associated/clusterlet',
                  reorderView: 'view/reorder',
                  removeLocks: 'locks/remove',
                  getMessageData: 'message',
                  rrdefsAndAssociates: 'rrdef/associates',
                  getUserTriggerList: 'user-trigger/associates',
                  getSingleUT: 'user-trigger/read-data',
                  getHandlerAssociates: 'handler/associates',
                  getAssetData: 'asset/read',
                  importEventTypes: 'message/import/file',
                  moveUserTrigger: 'user-trigger/move',
                  deleteInvokedTransaction: 'transaction/invoked-transaction/delete',
                  updateInvokedTransaction: 'transaction/invoked-transaction/update',
                  cloneTransaction: 'transaction/clone',
                  getEventParent: 'event/parent',
                  unnestChildTransaction: 'transaction/nested-transaction/unnest',
                  updateNestedOrder: 'transaction/nested/update',
                  srcDest: "event/sourcedest",
                  getFields: 'field/all-fields',
                  createTestcase: 'simulation/testcase/create',
                  getTestcaseTransactions: 'testcase/transactions',
                  updateTestcaseBasicDetails: 'testcase/update-basic-details',
                  updateTestcaseTransactions: 'testcase/update-transactions',
                  updateDelegates: 'testcase/update-delegates',
                  pasteTestcase: 'testcase/paste',
                  getSimulationData: "simulationDetails",
                  getTestcaseData: "testcaseDetails",
                  deleteTestcase: "testcase/delete",
                  getTestcase: "testcase",
                  updateTestcaseContext: 'testcase/context/update',
                  updateTestcase: "testcase/update",
                  getSimulationTestsuite: 'simulation/testsuite',
                  createTestsuite: 'simulation/testsuite/create',
                  updateSimulationTestsuite: 'simulation/testsuite/update',
                  deleteSimulationTestsuite: 'simulation/testsuite/delete',
                  updateTestsuiteContext: 'simulation/testsuite/context/update',
                  getTestcaseProfiles: 'simulation/profiles/testcase',
                  createTestcaseProfile: 'simulation/profiles/create/testcase',
                  updateTestcaseProfile: 'simulation/profiles/update/testcase',
                  deleteTestcaseProfile: 'simulation/profiles/delete/testcase',
                  getTestsuiteProfiles: 'simulation/profiles/testsuite',
                  createTestsuiteProfile: 'simulation/profiles/create/testsuite',
                  updateTestsuiteProfile: 'simulation/profiles/update/testsuite',
                  deleteTestsuiteProfile: 'simulation/profiles/delete/testsuite',
                  addSimulationTransaction: 'simulation/add-transaction',
                  findActiveTestcase: "simulation/find-active-testcase",
                  getCandidateEvents: "testcase/candidate-events",
                  updateEventInSimulationTransaction: "simulation-transaction/event/update",
                  getSimulationDeployConfig: "simulation-configuration/list",
                  getDeploymentConfigurationList: "simulations-configuration-list",
                  runSimulation: 'simulation/run',
                  listTestsuites: 'testsuite/listing',
                  listTestcases: 'testcases/listing',
                  getSimulationTransaction: 'simulation-transaction',
                  updateSimulationTransactionConfiguration: 'simulation-transaction/configurations/update',
                  checkScenarioExistence: 'scenario/check-availability',
                  remapClusterlets: 'transaction/clusterlets/remap',
                  getSimulationSavedCommands: 'simulation/saved-commands',
                  deleteSimulationTransaction: 'simulation/delete-transaction',
                  terminateSimulation: 'simulation/terminate-simulation',
                  getSimulationLogs: 'simulationLogs',
                  updateSimulationTransactionOrder: 'simulation/transaction/update-order',
                  getSavedDeployCommands: 'blueprint/saved-deployment',
                  validateBlueprint_old: 'blueprint/validate',
                  exportBlueprintfiles: 'export/blueprint',
                  getBlueprintDetails: 'blueprint/details',
                  undo: 'blueprint/undo',
                  redo: 'blueprint/redo',
                  getUndoRedoList: 'blueprint/undoRedo',
                  isTriggerEvent: 'event/isTriggerEvent',
                  getCustomIcons: 'asset/read-icons',
                  mergeImportedMessages: 'messages/import',
                  deleteTempData: '/blueprint/tempData/delete',
                  deleteTempDocument: '/blueprint/tempData/delete',
                  getSimulationBatches: 'simulation/batches',
                  getBatchLogs: "simulation/logs",
                  searchBatchLogs: "simulation/search",
                  reorderTransaction: 'transaction/reorder',
                  reorderClusterlet: 'clusterlet/reorder',
                  reorderUtilityFunction: 'utilityFunction/reorder',
                  getBuildBatches: 'blueprint/getBuildDeployBatches/build',
                  getDeployBatches: 'blueprint/getBuildDeployBatches/deploy',
                  getBuildDeployLogs: 'blueprint/getBuildDeployLogs',
                  blueprintBuild: 'blueprint/build',
                  blueprintDeploy: 'blueprint/deploy',
                  reorderDelegate: 'delegate/reorder',
                  reorderTestSuite: 'testsuite/reorder',
                  reorderTestCase: 'testcase/reorder',
                  testSimulationConfig: 'simulation-configuration/verify',
                  getGitConfiguration: 'git-configuration/fetch',
                  createGitConfiguration: 'git-configuration/create',
                  updateGitConfiguration: 'git-configuration/update',
                  deleteGitConfiguration: 'git-configuration/delete',
                  getOrPostUITour: 'ui-tour',
                  uploadPlatformSchema: 'platformschema/upload',
                  loadPlatformSchemaList: 'platformschema/listing',
                  getRrdefPlatformSchema: 'rrdef/get-form',
                  getDelegateProfileSchema: 'delegate-profile/get-schema',
                  createDatabaseProfileSchema: "delegate-profile/create-schema",
                  getDatabaseProfileData : "delegate-profile/get-schema-data",
                  deletePlatformSchema: 'platformschema/delete',
                  updateProbability: 'testsuite/probability',
                  getDbSchema:"delegate/message-schema",
                  checkPlatformSchemaMigration: 'platformschema/migration/check',
                  migratePlatformSchema: 'platformschema/migrate',
                  platformSchemaAvailableVersions: 'available-schema',
                  deleteProfile:"profile/delete",
                  getCompatibilityErrors: "platform-schema/compatibility-errors",
                  resolveMigrationError: 'platform-schema/resolve-error',
                  closeAllMigrationErrors: 'platform-schema/close-errors',
                  getDelegateProtocols: 'delegate/protocols/get',
                  searchIcons: 'icons/search',
                  updateInvokedOrder: 'transaction/invoked-transaction/updateorder',
                  getDashboardBuilder: 'dashboard/views',
                  updateSimulationChildConfiguration: 'simulation-child-transactions/configuration/update',
                  updateTransactionElementsOrder: 'transaction/order/update',
                  dockPosition: "drawer-dock", 
                  resolveAllErrors: "platform-schema/resolve-all-errors",
                  tourConfig: "tour-config.json",
                  updateTransactionElementName : "transaction/element/update",
                  llmGenerateComponents : "generate/components",
                  generateSystemModel: "ai/generate",
                  confirmSystemModelDeletion: "ai/confirm-deletion",
                  llmGenerateFlow : "generate/flow",
                  llmGenerateViewsList: "ai/views/list",
                  llmGenerateViews: "ai/views/heirarchy",
                  llmGenerateTxns: "ai/views/generate-section-transaction",
                  llmQueryPlan: "ai/views/query-plan",
                  llmViewMessageDef: "ai/views/fetch-txn-message-definition",
                  llmFetchHandlerCode: "ai/views/handler-code",
                  llmFetchHandlerDef: "ai/views/handler-definition",
                  llmSaveViewAndFetchTxns: "ai/views/save-generated-entities",
                  llmHandlerValidation: "ai/views/validate-generated-code",
                  llmLuaValidate: "ai/views/validate-lua-code",
                  createLlmModel : "llm/clusterlets/create",
                  getAllUtilityFunctions: 'utility_functions/get',
                  createUtilityFunction: 'utility_function/create',
                  validateBlueprint: 'blueprint/validate',
                  trainView: "train-llm-views",
                  trainSystemModel: "train-llm-system-model",
                  fetchViews: "views/get",
                  logTimeout: "ai/log-timeout",
                  updateLLMResponseInTrainingData: "ai/update-training-data",
                  llmGenerateTransactionList: "ai/transaction/list",
                  llmGenerateTransactionEvents: "ai/transaction/events",
                  llmGenerateFunctionalTransactionHandlers: "ai/transaction/fn-handler-def",
                  llmGenerateTestsuiteMessages: "ai/simulation/message",
                  llGenerateSimulationScenarios: "ai/simulation/scenarios",
                  llGenerateSimulationTestsuites: "ai/simulation/testsuites",
                  llGenerateSimulationTestsuiteUpdate: "ai/simulation/testsuite/update",
                  llGenerateSimulationConfirmTestsuiteModification: "ai/simulation/testsuite/confirm-modifications",
                  llmGenerationSystemModelNode: "ai/generate-system-model-nodes",
                  llmGenerationSystemModelConnection: "ai/generate-system-model-connections",
                  

                  llmFileUpload: "ai/file-analysis",
                  llmFileSummary: "ai/file-analysis/status",
                  llmSystemModelClarity: "ai/system-model-clarity",
                  llmViewsClarity: "ai/views/clarity",
                  llmTransactionClarity: "ai/transaction/clarity",
                  llmSimulationClarity: "ai/simulation/clarity",
                  databaseClarity: "ai/database/clarity",

                  fetchDatabaseProfileAndDelegateDetails: "ai/fetch-database-profiles",
                  llmGenerationSystemModelDBTables: "ai/generate-db-structure-tables",
                  llmGenerationSystemModelDBProfileSchema: "ai/generate-db-structure-schema",
                  llmGenerateDatabaseSampleData: "ai/database/sample-data",
                  getMainConstructs: "blueprints/main-constructs",
                  generateTransactionForSection: "ai/views/generate-section-transaction",
                  getLatestPlatformSchemaVersion: "platform-schema/latest/version",
                  getBlueprintPlatformSchemaHistory: "blueprint/platform-schema/history",
                  checkBlueprintOnLatestSchema: "platform-schema/latest/check",
                  generateHandler: "ai/handler/generate",
                  generateTransactionHandlerCode: "ai/transaction/handler-code",
                  getLLMTrainingLogs: "ai/training-logs",
                  deleteDatabaseSampleData: "delegate-profile/sample-data/delete",
                  downloadSampleData: "delegate-profile/sample-data/download",
                  downloadSampleDataFromLog: "ai/database/sample-data/download",

                  runtimeLogs: "logs/runtime",
                  ssliceInfo: "sslice-info",
                  changeSsliceLogLevel: "change-sslice-log-level",
                  restartSslice: "restart-sslice",
                  simulationLogs: "simulation/logs",
                  clearRuntimeLogs: "clear-runtime-logs",
                  redirectLink: "redirect-appview",
                  updateLLMLogAsStopped: "ai/training-log/update/stop"
            };
      }
}

export default SVC;
